import { EventSpeaker } from '@app/routes/content/domain';
import { TranscriptSpeaker } from '@app/routes/content/routes/recordings/domain';
import { selectRecordingTranscriptSpeakers } from '@app/routes/content/routes/recordings/selector';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SpeakerDetails } from './speaker-details';

export const SpeakerList = () => {
  const { t } = useTranslation();
  const speakersData = useSelector(selectRecordingTranscriptSpeakers);

  const speakers = useMemo(() => {
    if (!speakersData) return [];

    const addedSpeakerIds = new Set<string>();
    const speakers: Array<{
      speaker: EventSpeaker | TranscriptSpeaker;
      speakerKey: string;
    }> = [];

    // Deduplicate speakers by id
    for (const [key, value] of Object.entries(speakersData)) {
      if (value === null) {
        speakers.push({
          speaker: { name: key } as TranscriptSpeaker,
          speakerKey: key,
        });
      } else {
        const eventSpeaker = value as EventSpeaker;
        if (!addedSpeakerIds.has(eventSpeaker.id)) {
          addedSpeakerIds.add(eventSpeaker.id);
          speakers.push({ speaker: eventSpeaker, speakerKey: key });
        }
      }
    }

    return speakers;
  }, [speakersData]);

  return (
    <div className="bg-transparent relative rounded-lg border border-spring-neutral-b1/20">
      <div className="flex flex-col gap-3 items-start justify-start p-2 relative">
        <div className="font-medium leading-0 not-italic relative shrink-0 text-base text-white">
          {t('content-recording.content-menu.speakers')}
        </div>
        <div className="flex flex-col gap-2 items-start justify-start relative shrink-0 w-full max-h-32 overflow-y-auto pl-1 pr-0.5 py-0.5 [scrollbar-width:thin] [scrollbar-color:#696e7c_transparent]">
          {speakers.map(({ speaker, speakerKey }, index) => {
            return (
              <SpeakerDetails
                key={`${index}-${speakerKey}`}
                speaker={speaker}
                speakerKey={speakerKey}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
